'use strict';

import { find, forIn, map } from 'lodash';

var redirectController = function($controller, $window, workflowService) {

    var vm = this;
    angular.extend(vm, $controller('baseStepController'));

    vm.$onInit = function(){
        vm.initializeStep(vm.$stateParams).then(function (executionStep) {
            vm.executionStep = executionStep;

            var url = getParameterValue(executionStep.ticketStep.parameters, 'redirectUrl');
            var parametersToInclude = getParameterValue(executionStep.ticketStep.parameters, 'redirectParameters');
            var includeEmpty = getParameterValue(executionStep.ticketStep.parameters, 'redirectIncludesEmpty');

            return workflowService.completeTicketWithoutRedirect(vm.executionStep.ticketStep).then(ticket => {

                var urlHasQueryString = url && url.includes('?');
                var separator = !urlHasQueryString ? '?' : '&';
                url = url + separator + 'studyId=' + ticket.studyId +  '&ticketId=' + ticket.id;

                parametersToInclude.forEach(function (key) {
                    var value = ticket.parameters[key];

                    if (includeEmpty || value) {
                        value = value ? value : ''; // empty string if undefined or null
                        url = url + '&' + key + '=' + value;
                    }
                });

                //also include entry parameters
                var parameterCheck = map(parametersToInclude, (x) => { return x.toLowerCase(); });
                if (ticket.entryParameters)
                {
                    forIn(ticket.entryParameters, (v, k) => {
                        if (!parameterCheck.includes(k.toLowerCase())) {
                            url = url + '&' + k + '=' + v;
                        }
                    });
                }

                vm.redirect(url);
            });
        });
    };

    function getParameterValue(parameters, parameterName) {
        var param =  find(parameters, function(p) { 
            return p.argumentName === parameterName;
        });

        return param ? param.value : null;
    }

    vm.redirect = function(url) {
        $window.onbeforeunload = null;
        $window.location.href = url;
    };
};

redirectController.$inject = ['$controller', '$window', 'workflowService'];

export var redirectComponent = {
    name: 'redirect',
    controller : redirectController,
    bindings: {
        $stateParams: '<'
    }
};

export var redirectRoute = {
    name: 'redirect',
    url: '/redirect',
    component: 'redirect'
}